/**
 * M10 P5a11c: where the S appears after "Launch from the helm" (event-rate, pure). The L parks at the pose the player
 * flew it at; the S comes out of its `DOCK_CRADLE` socket: the socket's position plus `clearM` along the socket's out
 * axis (local −Z, `docking/bay.ts socketOut`), in the L's frame, then into the world at the L's float64 pose (D-013).
 * Without a socket the S appears `clearM` below the L's origin (its local −Y).
 */
import { rotateVec, type Quat, type Vec3 } from '../../core/math'
import { socketOut, type BaySocket } from '../../docking/bay'

const out: Vec3 = { x: 0, y: 0, z: 0 }
const local: Vec3 = { x: 0, y: 0, z: 0 }

/** Writes the S's float64 world position into `into` and returns it. */
export function launchClearPoint(pos: readonly [number, number, number], rot: Readonly<Quat>, socket: BaySocket | null, clearM: number, into: Vec3): Vec3 {
  let lx = 0
  let ly = -clearM
  let lz = 0
  if (socket !== null) {
    socketOut(socket, out)
    lx = socket.position[0] + out.x * clearM
    ly = socket.position[1] + out.y * clearM
    lz = socket.position[2] + out.z * clearM
  }
  rotateVec(rot, lx, ly, lz, local)
  into.x = pos[0] + local.x
  into.y = pos[1] + local.y
  into.z = pos[2] + local.z
  return into
}
